import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, Divider, Paper, ListItemIcon } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'; // Import bullet point icon

const PrivacyPolicy: React.FC = () => {
    return (
        <Container maxWidth="xl" sx={{ mt: 6, mb: 6 }}>
            <Paper elevation={3} sx={{ py: 4, px: 3, backgroundColor: 'transparent', color: '#ffffff' }}>
                <Box textAlign="center" mb={4}>
                    <Typography variant="h3" gutterBottom sx={{ color: 'primary.main', fontSize: '26px' }}>
                        Privacy Policy
                    </Typography>
                    <Divider sx={{ mt: 2, mb: 2, backgroundColor: 'primary.main' }} />
                </Box>

                <Box mb={4}>
                    <Typography variant="body1" paragraph>
                        This privacy policy sets out how “Kolla Group” uses and protects any information that you give “Kolla Group” when you use this website.
                    </Typography>
                    <Typography variant="body1" paragraph>
                    “Kolla Group” is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        “Kolla Group” may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        This policy is effective from August, 2023.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        What We Collect
                    </Typography>
                   
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="Name and job title" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="Contact information including email address" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="Demographic information such as postcode, preferences, and interests" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="Other information relevant to customer surveys and/or offers" />
                        </ListItem>
                    </List>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        What We Do With the Information We Gather | We Gather
                    </Typography>
                    <Typography variant="body1" paragraph>
                    We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="Internal record keeping" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="We may use the information to improve our products and services." />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="We may periodically send promotional email about new products, special offers or other information which we think you may find interesting using the email address which you have provided." />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, fax or mail." />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="We may use the information to customize the website according to your interests." />
                        </ListItem>
                    </List>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Security
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure, we have put in place suitable physical, electronic, and managerial procedures to safeguard and secure the information we collect online.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        How We Use Cookies
                    </Typography>
                    <Typography variant="body1" paragraph>
                        A cookie is a small file that asks permission to be placed on your computer’s hard drive. Once you agree, the file is added, and the cookie helps analyze web traffic or lets you know when you visit a particular site.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes, and dislikes by gathering and remembering information about your preferences.
                    </Typography>
                    <Typography variant="body1" paragraph>
                    We use traffic log cookies to identify which pages are being used. This helps us analyse data about web page traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.                     
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.                                        
                        </Typography>
                    <Typography variant="body1" paragraph>You can choose to accept or decline cookies. Most web browsers automatically accept
                    cookies, but you can usually modify your browser setting to decline cookies if you prefer.
                    This may prevent you from taking full advantage of the website.                    </Typography>
                                    </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Links to Other Websites
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Our website may contain links to enable you to visit other websites of interest easily. However, once you have used these links to leave our site, you should note that we do not have any control over that other website.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement.                    
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You should exercise caution and look at the privacy statement applicable to the website in question.                    
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Controlling Your Personal Information
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You may choose to restrict the collection or use of your personal information in the following ways:
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used by anybody for direct marketing purposes" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecordIcon  sx={{fontSize:"14px", color: 'primary.main' }} />
                            </ListItemIcon>
                            <ListItemText primary="if you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or email us" />
                        </ListItem>
                    </List>
                    <Typography variant="body1" paragraph>
                        We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Terms & Conditions
                    </Typography>
                    <Typography variant="body1" paragraph>
                        To avail the services offered at www.kollagroup.com, you must agree to the following terms and conditions:
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Please read the term and conditions carefully. While using any current or future services offered by www.kollagroup.com, whether or not included in the www.kollagroup.com. Website, you will abide by these Terms &amp; conditions the guidelines and conditions applicable to such service or business.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Electronic Communication
                    </Typography>
                    <Typography variant="body1" paragraph>
                        When you visit www.kollagroup.com or voluntarily send e-mails to us, you are communicating with us electronically. We will keep record of this information so that we can respond to you periodically. We only collect information from you when you register on our website or fill out a form. Also, when filling out a form on our website, you may be asked to enter your: Name, E-mail address or Phone / Mobile Number. You may, however visit our website anonymously.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        By communicating with us and submitting your personal information and contact details, you consent to receive communication from us through Email, SMS, Call, WhatsApp or any other communication medium, even if your number has DND activated on it. You agree that all agreements, notices, disclosures, and other communications that we provide to you electronically satisfy any legal requirement that such communication be in writing.
                    </Typography>
                </Box>


                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        License and Website Access
                    </Typography>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        General:
                    </Typography>
                    <Typography variant="body1" paragraph>
                        www.kollagroup.com grants you a limited license to access and make personal use of this website and not to download (other than page caching) or modify it, or any portion of it, except with express written consent of www.kollagroup.com
                    </Typography>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        No license for commercial sale:
                    </Typography>
                    <Typography variant="body1" paragraph>
                    This license does not include any resale or commercial use of this website or its content; any collection and use of any product listing, description, or pricing; copying of account information for the benefit of another merchant; or any use of data mining, or similar data gathering and extraction tools.
                    </Typography>
                </Box>


                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        No reproduction:
                    </Typography>
                    <Typography variant="body1" paragraph>
                        This website or any portion of this website may not be reproduced, duplicated, copies, sold, visited, or otherwise exploited for any commercial purpose without express written consent of Www.kollagroup.com                   
                    </Typography>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        No framing:
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You may not frame or utilize framing technologies to enclose any trademark, logo, or other proprietary information (including images, text, page layout, or form) of www.kollagroup.comwithout the express written consent.
                    </Typography>
                </Box>


                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                    Metatags:
                    </Typography>
                    <Typography variant="body1" paragraph>
                    You may not use any metatags or any other &#39;hidden text&#39; utilizing Jain Construction’s name or trademarks without the express written consent of www.kollagroup.com. Any unauthorized use terminates the permission or license granted by www.kollagroup.com                   
                    </Typography>
                    <Typography variant="body1" paragraph>
                    Reviews, Comments, Communications, and other content
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Nature of Content
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Visitors to www.kollagroup.com may post content and other communications; and submit suggestions, ideas, comments, questions, or other information, as long as the content is not illegal, obscene, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, mass mailing, or any form of spam.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        False Information
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You may not use false email addresses, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. www.kollagroup.com reserves the right (but not the obligation) to remove or edit such content but does not regularly review posted contents.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Rights Granted
                    </Typography>
                    <Typography variant="body1" paragraph>
                        If you do post content or submit material and unless we indicate otherwise, you grant www.kollagroup.com a non-exclusive, royalty-free, perpetual, irrevocable, and fully sub-licensed right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such content throughout the world in any media. You grant www.kollagroup.com the right to use the name that you submit in connection with such content if www.kollagroup.com chooses.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Right Owned
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You represent and warrant that you own all the rights or otherwise control all of the rights to the content that you post; that the content is accurate; that the use of the content you supply does not violate this policy and will not cause injury to any person or entity, and that you will indemnify www.kollagroup.com for all claims resulting from the content you supply. www.kollagroup.com has the right but not the obligation to monitor and edit or remove any activity or content. www.kollagroup.com takes no responsibility and assumes no liability for any content posted by you or any third party.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Site Policies, Modification, and Severability
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Please review our other policies. We reserve the right to make changes to our website, policies, and these Terms and Conditions at any time. If any of these conditions shall be deemed invalid, void, or for any reason unenforceable, that condition shall be deemed severable and will not affect the validity and enforceability of any remaining conditions.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Intellectual Property Rights
                    </Typography>
                    <Typography variant="h6" component="h3" gutterBottom sx={{ color: 'primary.main' }}>
                        Copyright Protection
                    </Typography>
                    <Typography variant="body1" paragraph>
                        All content included on this site, such as text, graphics, logos, button icons, audio clips, digital downloads, data compilations, and software, is the property of www.kollagroup.com and protected by Indian Copyright law. The compilation of all the content on this site is the exclusive property of www.kollagroup.com and protected by Indian Copyright law. All software used on this site is the property of www.kollagroup.com and is protected under Indian Copyright law.
                    </Typography>
                    <Typography variant="h6" component="h3" gutterBottom sx={{ color: 'primary.main' }}>
                        Trademarks
                    </Typography>
                    <Typography variant="body1" paragraph>
                        www.kollagroup.com and other marks indicated on the www.kollagroup.com website are registered trademarks of www.kollagroup.com.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Governing Law and Jurisdiction
                    </Typography>
                    <Typography variant="body1" paragraph>
                        These terms and conditions will be construed only in accordance with the laws of India. In respect of all matters/disputes arising out of, in connection with, or in relation to these terms and conditions or any other conditions on this website, only the competent Courts at Hyderabad, India shall have jurisdiction, to the exclusion of all other courts.
                    </Typography>
                </Box>

                <Box mb={4}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
                        Disclaimer of Warranties and Limitation of Liability
                    </Typography>
                    <Typography variant="body1" paragraph>
                        THIS SITE IS PROVIDED BY KOLLA GROUP ON AN "AS IS" AND "AS AVAILABLE" BASIS. KOLLA GROUP MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THIS SITE OR THE INFORMATION, CONTENT, MATERIALS, OR PRODUCTS INCLUDED ON THIS SITE. YOU EXPRESSLY AGREE THAT YOUR USE OF THIS SITE IS AT YOUR SOLE RISK.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        TO THE FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, WWW.KOLLAGROUP.COM DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. WWW.KOLLAGROUP.COM DOES NOT WARRANT THAT THE SITE, ITS SERVERS, OR EMAIL SENT FROM WWW.KOLLAGROUP.COM ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WWW.KOLLAGROUP.COM WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS SITE, INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES.
                    </Typography>
                </Box>

                <Box textAlign="center" mt={4}>
                    <Typography variant="caption" display="block" sx={{ color: 'primary.main' }}>
                        © 2023 Kolla Group. All rights reserved.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default PrivacyPolicy;